// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCFr7saKKZ09tnScxvmlNUdhrTYSBQF16I",
  authDomain: "school-c07ba.firebaseapp.com",
  projectId: "school-c07ba",
  storageBucket: "school-c07ba.firebasestorage.app",
  messagingSenderId: "976370839750",
  appId: "1:976370839750:web:b5c3084b9ef1e3fc8327c7",
  measurementId: "G-L8Q9JK906V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

export { signInWithPopup, signOut };